import { useMemo } from 'react';
import { getDefaultSigningTypeFromAppointmentType } from '../utilities/getDefaultSigningTypeFromAppointmentType';
import { CreateSigningAppointmentFormData } from '../../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { IDetailsFormData } from '../types/IDetailsFormData';
import { useSelectCurrentOrder } from '../../../../../../../selectors/order/selectCurrentOrder';

const DSS_TIME_DEFAULT_VALUES = {
  dssStartTime: '08:00:00',
  dssEndTime: '15:00:00',
};

const useBuildInitialFormData = (wizardFormData: CreateSigningAppointmentFormData): IDetailsFormData => {
  const { data: order } = useSelectCurrentOrder();
  const transactionCategory = order.transaction.transaction_category;
  return useMemo(() => {
    return {
      address: wizardFormData.address,
      appointmentDate: wizardFormData.appointmentDate,
      appointmentTime: wizardFormData.appointmentTime,
      availableStartDate: wizardFormData.availableStartDate,
      availableEndDate: wizardFormData.availableEndDate,
      signingType:
        wizardFormData.signingType ??
        getDefaultSigningTypeFromAppointmentType(wizardFormData.ownerType, transactionCategory),
      signingMethod: wizardFormData.signingMethod,
      language: wizardFormData.language ?? 'English',
      ownerType: wizardFormData.ownerType,
      notes: wizardFormData.notes,
      isDateRange: wizardFormData.isDateRange,
      isSignatureSyncAppointment: wizardFormData.isSignatureSyncAppointment,
      correctionReasons: wizardFormData.correctionReasons,
      isDigitalScheduling: wizardFormData.isDigitalScheduling,
      isDigitalSchedulingDraft: wizardFormData.isDigitalSchedulingDraft,
      signerWillProvideLocation: wizardFormData.signerWillProvideLocation,
      signerSelectsFromRange: wizardFormData.signerSelectsFromRange,
      dssAppointmentOptions: wizardFormData.dssAppointmentOptions,
      isDssDateRange: wizardFormData.isDssDateRange,
      dssDateRangeStart: wizardFormData.dssDateRangeStart,
      dssDateRangeEnd: wizardFormData.dssDateRangeEnd,
      dssDate: wizardFormData.dssDate,
      dssStartTime: wizardFormData.dssStartTime || DSS_TIME_DEFAULT_VALUES.dssStartTime,
      dssEndTime: wizardFormData.dssEndTime || DSS_TIME_DEFAULT_VALUES.dssEndTime,
    };
  }, [
    wizardFormData.address,
    wizardFormData.appointmentDate,
    wizardFormData.appointmentTime,
    wizardFormData.availableStartDate,
    wizardFormData.availableEndDate,
    wizardFormData.signingType,
    wizardFormData.ownerType,
    wizardFormData.language,
    wizardFormData.notes,
    wizardFormData.isDateRange,
    wizardFormData.isSignatureSyncAppointment,
    wizardFormData.correctionReasons,
    wizardFormData.signingMethod,
    wizardFormData.isDigitalScheduling,
    wizardFormData.isDigitalSchedulingDraft,
    transactionCategory,
    wizardFormData.signerWillProvideLocation,
    wizardFormData.signerSelectsFromRange,
    wizardFormData.dssAppointmentOptions,
    wizardFormData.isDssDateRange,
    wizardFormData.dssDateRangeStart,
    wizardFormData.dssDateRangeEnd,
    wizardFormData.dssDate,
    wizardFormData.dssStartTime,
    wizardFormData.dssEndTime,
  ]);
};

export default useBuildInitialFormData;
